export default "https://cdn-static.gokick.com/assets/adaefb0e3fd6b18bbcda680789a7f58b9251a870/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";